import { ItemView } from './common/CommonComponents';
import { useLanguage } from '../utils/LanguageContext';
import translations from './ComponentsTranslations.lang.json';

const PasswordView = () => {
  const { lang } = useLanguage(translations);

  const items = [
    {
      field: 'password',
      value: lang('passwordNotShown'),
    },
  ];

  return <ItemView items={items} />;
};

export default PasswordView;
